import type { PlayableItemDto } from '../dto/playableItemDto';
import type { PlaybackQuality, QualityOption } from '../types/playbackQuality';
import { playableArtifactToQuality } from './playableArtifactToQuality';

export function getAvailableQualitiesFromItem(payload: PlayableItemDto, failedQualities: Map<PlaybackQuality, string> | null): QualityOption[] {
  const options: QualityOption[] = [];

  for (const artifactEntry of payload.availableArtifacts) {
    const quality = playableArtifactToQuality(artifactEntry);
    if (quality) {
      const failedReason = failedQualities?.get(quality);
      const disabledText = artifactEntry.playableStatus === 'unplayable' ? artifactEntry.reason : undefined;
      const warningText = artifactEntry.playableStatus === 'playable' ? artifactEntry.warning : undefined;
      options.push({
        quality,
        disabledText: failedReason ?? disabledText,
        warningText,
      });
    }
  }
  return options;
}

